import React, { useState, useEffect } from "react";

function CoursePdf(props) {
  return (
    <div className="">
      <div className="Header">
        <span className="cat-title">
          {localStorage.getItem("pdfTitle")}
          <i
            className="icon-arrow-down-sign-to-navigate"
            onClick={() => props.history.goBack()}
          ></i>
        </span>
      </div>
      <div style={{ position: "relative" }}>
        <object
          data={`${localStorage.getItem("pdfLink")}#toolbar=0`}
          type="application/pdf"
          width="100%"
          height="100%"
          style={{
            height: "89vh",
          }}
        ></object>
      </div>
    </div>
  );
}
export default CoursePdf;
